/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Targeted Deorbit component for PMD Phase  
Author: Deimos Space UK

Version: 1.0
*/
import React from 'react'
import Select from 'react-select';
import { Row, Col, Form, OverlayTrigger, Tooltip, } from 'react-bootstrap';
import style from '../PMDPhase.module.css'
function TargetedDeorbit(props) {
    return (
        <div className={style.row}>
            <Row className={style.rowForm}>
                <Col xs={6} md={4} className={style.row}>

                    <Select

                        className="react-select"
                        classNamePrefix="react-select"
                        value={props?.step4?.targetedDeorbitData?.disposalSystem}
                        onChange={(value) => props.onChangeDisposalSystemTargetedDeorbit(value)}
                        isDisabled={false}
                        options={props.propulsionType === 'chemical' ? [

                            { value: 'chemical', label: 'Chemical' },

                            { value: 'dad', label: 'Drag Augmentation Device' },
                        ] : [
                            { value: 'electrical', label: 'Electrical' },
                            { value: 'dad', label: 'Drag Augmentation Device' },

                        ]}></Select>
                </Col>
                {
                    props.step4?.targetedDeorbitData?.disposalSystem && props.step4?.targetedDeorbitData?.disposalSystem.value === 'chemical' &&
                    <Col xs={6} md={4} className={style.row}>
                        <Form.Group controlId="semiMajorAxis">
                            <OverlayTrigger
                                key={'right'}
                                placement={'left'}
                                overlay={
                                    <Tooltip id={`tooltip-right`}>
                                        Number of Hohmann transfer manoeuvers required to reach the desired orbit.
                                    </Tooltip>
                                }>
                                <Form.Label>Hohmann transfer manoeuvres</Form.Label>
                            </OverlayTrigger>
                            <Form.Control
                                isInvalid={isNaN(props.step4?.targetedDeorbitData?.hohmannTransfer) && props.step4?.targetedDeorbitData?.hohmannTransfer !== ''} s
                                disabled={props.disabled}
                                value={props.step4?.targetedDeorbitData?.hohmannTransfer}
                                onChange={e => props.changeHohmannTransfer(e.target.value)} type="string" />
                        </Form.Group>
                    </Col>
                }

                <Col xs={6} md={4} className={style.row}>

                    <Form.Group controlId="endDate" className={style.row}>
                        <Form.Label>Lifetime limit [years]</Form.Label>
                        <Form.Control
                            isInvalid={isNaN(props.step4?.targetedDeorbitData?.lifetimeLimit) && props.step4?.targetedDeorbitData?.lifetimeLimit !== ''} s
                            disabled={props.disabled}
                            value={props.step4?.targetedDeorbitData?.lifetimeLimit}
                            onChange={e => props.changeLifetimeLimit(e.target.value)} type="string" />
                    </Form.Group>
                </Col >

            </Row>
            {props.step4?.targetedDeorbitData?.disposalSystem && props.step4?.targetedDeorbitData?.disposalSystem && props.step4?.targetedDeorbitData?.disposalSystem.value === 'dad' ?
                <Row className={style.rowForm}>
                    <Col xs={6} md={4} >
                        <Form.Group className={style.manualInput} controlId="semiMajorAxis">
                            <Form.Label>Cross section (m<sup>2</sup>)</Form.Label>
                            <Form.Control
                                isInvalid={isNaN(props.step4?.targetedDeorbitData?.crossSection) && props.step4?.targetedDeorbitData?.crossSection !== ''} s
                                disabled={props.disabled}
                                value={props.step4?.targetedDeorbitData?.crossSection}
                                type="string" onChange={e => props.changeTargetedDeorbitCrossSection(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col xs={6} md={4} >
                        <Form.Group className={style.manualInput} controlId="semiMajorAxis">
                            <Form.Label>Drag coefficient</Form.Label>
                            <Form.Control
                                isInvalid={isNaN(props.step4?.targetedDeorbitData?.dragCoefficient) && props.step4?.targetedDeorbitData?.dragCoefficient !== ''} s
                                disabled={props.disabled}
                                value={props.step4?.targetedDeorbitData?.dragCoefficient}
                                type="string" onChange={e => props.changeTargetedDeorbitDragCoefficient(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col xs={6} md={4} >
                        <Form.Group className={style.manualInput} controlId="semiMajorAxis">
                            <Form.Label>Reflectivity coefficient</Form.Label>
                            <Form.Control
                                isInvalid={isNaN(props.step4?.targetedDeorbitData?.reflectivityCoefficient) && props.step4?.targetedDeorbitData?.reflectivityCoefficient !== ''} s
                                disabled={props.disabled}
                                value={props.step4?.targetedDeorbitData?.reflectivityCoefficient}
                                type="string" onChange={e => props.changeTargetedDeorbitReflectivityCoefficient(e.target.value)} />
                        </Form.Group>
                    </Col>
                </Row>
                : null

            }




        </div>
    )
}

export default TargetedDeorbit